import { priceFormater } from '@/settings/index';
import { PriceInformationProps } from './types';

const PriceInformation = ({
  price,
  monthlyPrice,
  className,
}: PriceInformationProps) => (
  <span className={className}>
    {priceFormater.long(price)} ({monthlyPrice}/mo)
  </span>
);

export default PriceInformation;
